import { getHeaders } from './common';

const API_BASE_URL = process.env.REACT_APP_DEVICE_API_URL;

// 工具函数：构造 query string，过滤掉 null / undefined / ""
const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
};

// 客服搜索接口
export const customerSupportSearch = async (options = {}) => {
  const {
    page = 1,
    pageSize = 100,
    includeProfilePicture = false,
    searchTerm = "",
    deviceType = "",
    isLeader,            
    createdAfter = "",
    createdBefore = "",
    sortBy = "CreatedAt",
    sortOrder = "desc",
  } = options;

  let isLeaderParam;
  if (typeof isLeader === "boolean") {
    isLeaderParam = isLeader;
  } else if (typeof isLeader === "string" && isLeader !== "") {
    isLeaderParam = isLeader === "true";
  }

  const queryString = buildQueryString({
    page,
    pageSize,
    include_profile_picture: includeProfilePicture,
    searchTerm: searchTerm.trim(),
    deviceType,
    isLeader: isLeaderParam,
    createdAfter,
    createdBefore,
    sortBy,
    sortOrder,
  });

  try {
    const response = await fetch(
      `${API_BASE_URL}/customer_support_search?${queryString}`,
      {
        method: "GET",
        headers: getHeaders(),  
        credentials: "include",  
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data, status: response.status };
    } else {
      let errorText;
      try {
        errorText = await response.text();
      } catch {
        errorText = "Failed to fetch devices";
      }

      console.error("Failed to fetch devices:", errorText);
      return {
        success: false,
        error: errorText || "Failed to fetch devices",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error fetching devices:", error);
    return { success: false, error: error.message, status: 0 };
  }
};

// 获取设备类型
export const fetchDeviceTypes = async () => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/get_device_types`,
      {
        method: "GET",
        headers: getHeaders(),  
        credentials: "include",
      }
    );

    if (response.ok) {
      const data = await response.json();
      return { success: true, data, status: response.status };
    } else {
      console.error("Failed to fetch device types.");
      return {
        success: false,
        error: "Failed to fetch device types",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error fetching device types:", error);
    return { success: false, error: error.message, status: 0 };
  }
};
